import { useState, useEffect } from "react";
import { api, timeAgo } from "../../context";

export default function Verification({ t }) {
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [rejectNote, setRejectNote] = useState({});
  const [loading, setLoading] = useState(true);
  const [flash, setFlash] = useState("");

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const load = async () => {
    setLoading(true);
    const r = await api(`/admin/verifications?status=${filter}`);
    if (r.ok) setRequests(r.data?.data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, [filter]);

  const approve = async (id) => {
    const r = await api(`/admin/verifications/${id}/approve`, { method: "POST" });
    if (r.ok) { showFlash("User verified! ✓"); setRequests(p => p.filter(v => v.id !== id)); }
    else showFlash("Failed");
  };

  const reject = async (id) => {
    if (!rejectNote[id]?.trim()) { showFlash("Add a rejection reason first"); return; }
    const r = await api(`/admin/verifications/${id}/reject`, { method: "POST", body: JSON.stringify({ note: rejectNote[id] }) });
    if (r.ok) { showFlash("Rejected"); setRequests(p => p.filter(v => v.id !== id)); }
  };

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>🛡️ Verification Requests</div>
          <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{requests.length} {filter} requests</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {["pending", "approved", "rejected"].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              style={{ padding: "8px 16px", borderRadius: 10, border: `1.5px solid ${filter === f ? PRI : BORDER}`, background: filter === f ? `${PRI}15` : "transparent", color: filter === f ? PRI : SUB, fontSize: 12, fontWeight: 700, cursor: "pointer", textTransform: "capitalize" }}>
              {f === "pending" ? "⏳" : f === "approved" ? "✅" : "❌"} {f}
            </button>
          ))}
        </div>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 40, color: SUB }}>Loading...</div>}

      {!loading && !requests.length && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "60px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>🛡️</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 8 }}>No {filter} requests</div>
          <div style={{ fontSize: 13, color: SUB }}>{filter === "pending" ? "All caught up! ✓" : `No ${filter} verifications yet`}</div>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        {requests.map(vr => (
          <div key={vr.id} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: 20 }}>
            {/* User info */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
              {vr.user?.avatar_url
                ? <img src={vr.user.avatar_url} style={{ width: 48, height: 48, borderRadius: 24, objectFit: "cover" }} alt="" />
                : <div style={{ width: 48, height: 48, borderRadius: 24, background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>{vr.user?.avatar_emoji || "👤"}</div>
              }
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: TEXT }}>{vr.user?.name || "Unknown"}</div>
                <div style={{ fontSize: 11, color: SUB }}>Trust: {vr.user?.trust_score || 0} · {vr.user?.plan || "free"} · {timeAgo(vr.created_at)}</div>
              </div>
              <span style={{ padding: "4px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: vr.status === "pending" ? `${GOLD}20` : vr.status === "approved" ? `${GRN}20` : `${RED}20`, color: vr.status === "pending" ? GOLD : vr.status === "approved" ? GRN : RED }}>
                {vr.status}
              </span>
            </div>

            {/* Social links */}
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 14 }}>
              {vr.instagram && (
                <a href={`https://instagram.com/${vr.instagram}`} target="_blank" rel="noopener noreferrer"
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 10, background: t.input, color: TEXT, textDecoration: "none", fontSize: 13, fontWeight: 600 }}>
                  📸 @{vr.instagram}
                </a>
              )}
              {vr.twitter && (
                <a href={`https://x.com/${vr.twitter}`} target="_blank" rel="noopener noreferrer"
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 10, background: t.input, color: TEXT, textDecoration: "none", fontSize: 13, fontWeight: 600 }}>
                  🐦 @{vr.twitter}
                </a>
              )}
              {vr.facebook && (
                <a href={vr.facebook.startsWith("http") ? vr.facebook : `https://facebook.com/${vr.facebook}`} target="_blank" rel="noopener noreferrer"
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 10, background: t.input, color: TEXT, textDecoration: "none", fontSize: 13, fontWeight: 600 }}>
                  📘 {vr.facebook}
                </a>
              )}
            </div>

            {/* Actions */}
            {vr.status === "pending" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <input placeholder="Rejection reason (required to reject)..."
                  value={rejectNote[vr.id] || ""}
                  onChange={e => setRejectNote({ ...rejectNote, [vr.id]: e.target.value })}
                  style={{ padding: "8px 12px", borderRadius: 9, border: `1px solid ${BORDER}`, background: t.input, color: TEXT, fontSize: 12, outline: "none", fontFamily: "inherit" }} />
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => approve(vr.id)} style={{ flex: 1, padding: "10px 0", borderRadius: 10, border: "none", background: GRN, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>✓ Approve</button>
                  <button onClick={() => reject(vr.id)} style={{ flex: 1, padding: "10px 0", borderRadius: 10, border: "none", background: RED, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>✗ Reject</button>
                </div>
              </div>
            )}
            {vr.status !== "pending" && vr.admin_note && (
              <div style={{ fontSize: 12, color: SUB, fontStyle: "italic", padding: "8px 12px", background: t.input, borderRadius: 8 }}>Note: {vr.admin_note}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}